import { authFetch } from '../../auth/authFetch';
import { getApiBaseUrl } from '../../auth/api';
import type { ApiResponse } from '../organisation/organisationApiTypes';

export type StpAuditCategory = 'configuration' | 'identity' | 'pay_event' | 'state_transition';
export interface StpAuditEvent {
  eventId: string; sourceKind: string; sourceEventId: string; category: StpAuditCategory; eventType: string;
  occurredAtUtc: string; actor: { kind: string; id: string }; outcome: string; summary: string;
  correlationId?: string; reference?: { kind: string; value: string }; href?: string;
}
export interface StpAuditPage { items: StpAuditEvent[]; nextCursor?: string; coverage: { sourceKind: string; description: string }[] }
export interface StpAuditFilters { category?: string; eventType?: string; actor?: string; outcome?: string; correlation?: string; reference?: string; from?: string; to?: string; cursor?: string }

export const getStpAuditEvents = async (businessRecordId: string, filters: StpAuditFilters = {}): Promise<StpAuditPage> => {
  const query = new URLSearchParams({ pageSize: '50' });
  Object.entries(filters).forEach(([key, value]) => { if (value) query.set(key, value); });
  const response = await authFetch(`${getApiBaseUrl()}/api/business-records/${encodeURIComponent(businessRecordId)}/stp/audit-events?${query}`);
  const body = await response.json() as ApiResponse<StpAuditPage>;
  if (!response.ok || !body.result) throw new Error(body.message ?? `Request failed: ${response.status}`);
  return body.result;
};
